webpackJsonp([22885490386278],{

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Post = __webpack_require__(59);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Sidebar = __webpack_require__(19);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _optimization = __webpack_require__(343);
	
	var _optimization2 = _interopRequireDefault(_optimization);
	
	var _practical_tips = __webpack_require__(344);
	
	var _practical_tips2 = _interopRequireDefault(_practical_tips);
	
	var _more_on_embeddings = __webpack_require__(345);
	
	var _more_on_embeddings2 = _interopRequireDefault(_more_on_embeddings);
	
	var _more_on_transformers = __webpack_require__(346);
	
	var _more_on_transformers2 = _interopRequireDefault(_more_on_transformers);
	
	var _RL_for_dialogues = __webpack_require__(347);
	
	var _RL_for_dialogues2 = _interopRequireDefault(_RL_for_dialogues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// slides
	
	
	var Publications = function (_React$Component) {
	  _inherits(Publications, _React$Component);
	
	  function Publications() {
	    _classCallCheck(this, Publications);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Publications.prototype.render = function render() {
	    var items = [];
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	
	    var posts = this.props.data.allMarkdownRemark.edges;
	
	    // posts.forEach((post, i) => {
	    //  items.push(<Post data={post} key={post.node.fields.slug} index={i} />);
	    // });
	
	    var adl = _react2.default.createElement(
	      'div',
	      null,
	      'Applied Deep Learning'
	    );
	
	    var vivianLink = "https://www.csie.ntu.edu.tw/~yvchen/index.html";
	    var websiteLink = "https://www.csie.ntu.edu.tw/~miulab/s108-adl/syllabus.html";
	
	    var video1 = "https://www.youtube.com/watch?v=ewNb46KswNo&feature=youtu.be";
	    var video2 = "https://www.youtube.com/watch?v=nXRsd9DTSwA&feature=youtu.be";
	    var video3 = "https://www.youtube.com/watch?v=scvvl6ueHuM&feature=youtu.be";
	    var video4 = "https://www.youtube.com/watch?v=p4arkqf-B5w&feature=youtu.be";
	    var video5 = "https://www.youtube.com/watch?v=QIDvnxuW20U";
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle })
	      ),
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner', style: { overflow: "scroll", height: "85vh" } },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Applied Deep Learning'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { color: "grey" } },
	            'Course Website: ',
	            _react2.default.createElement(
	              'span',
	              null,
	              ' '
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: websiteLink, target: '_blank' },
	              '(Spring, 2020)'
	            ),
	            _react2.default.createElement('br', null),
	            'Lectured supplementary courses with ',
	            _react2.default.createElement(
	              'a',
	              { href: vivianLink, target: '_blank' },
	              'Yun-Nung (Vivian) Chen'
	            ),
	            _react2.default.createElement('br', null),
	            'Department of Computer Science and Information Engineering,',
	            _react2.default.createElement('br', null),
	            'National Taiwan University',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'em',
	              null,
	              'Note: the courses are taught in Mandarin, the materials are in Engish'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { style: { listStyleType: "square" } },
	              _react2.default.createElement(
	                'li',
	                null,
	                'Optimization: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: _optimization2.default, target: '_blank' },
	                  'slides'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: video1, target: '_blank' },
	                  'YouTube'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Practical Tips: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: _practical_tips2.default, target: '_blank' },
	                  'slides'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: video2, target: '_blank' },
	                  'YouTube'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'More on Embeddings: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: _more_on_embeddings2.default, target: '_blank' },
	                  'slides'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: video3, target: '_blank' },
	                  'YouTube'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'More on Transformers: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: _more_on_transformers2.default, target: '_blank' },
	                  'slides'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: video4, target: '_blank' },
	                  'YouTube'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'RL for Dialogues: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: _RL_for_dialogues2.default, target: '_blank' },
	                  'slides'
	                ),
	                ', ',
	                _react2.default.createElement(
	                  'a',
	                  { href: video5, target: '_blank' },
	                  'YouTube'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Publications;
	}(_react2.default.Component);
	
	exports.default = Publications;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/200310_optimization.bad0adb0.pdf";

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/200317_practical_tips.427e4a9e.pdf";

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/200331_more_on_embeddings.5844ccb2.pdf";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/200414_more_on_transformers.6badfe90.pdf";

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/200512_RL_for_dialogues.4b833efc.pdf";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-teaching-jsx-5b951e52577eae849781.js